import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaReply } from "react-icons/fa6";
import Pagination from "Components/Pagination/Pagination";
import ContactSkeleton from "Screens/Admin/ContactUs/ContactSkeleton";
import ReplyModal from "./ReplyModal";

const ContactUs = () => {
  const [issues, setIssues] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 6;

  useEffect(() => {
    getAllIssues(currentPage);
  }, [currentPage]);

  const getAllIssues = async (page = 1) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/user-issue/get-all`,
        {
          params: { userType: "admin", page, limit: itemsPerPage },
        }
      );
      setIssues(res.data.issues || []);
      const total = res.data.total || 0;
      setTotalPages(Math.ceil(total / itemsPerPage));
    } catch (error) {
      console.error("Error fetching issues:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleReplyClick = (issue) => {
    setSelectedIssue(issue);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedIssue(null);
  };

  return (
    <div className="min-h-screen  pt-5">
      {loading ? (
        <ContactSkeleton />
      ) : (
        <>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {issues.length > 0 ? (
              issues.map((issue, index) => (
                <div
                  key={index}
                  className=" flex h-[75%] max-w-md flex-col justify-between rounded-lg bg-white text-center shadow-md "
                >
                  <div className="relative h-40 overflow-hidden px-5 pb-10 pt-5 text-center">
                    <h3 className="text-lg font-semibold text-gray-800">
                      {issue.subject}
                    </h3>
                    <p className="mt-2 line-clamp-3 text-gray-700">
                      {issue.description}
                    </p>

                    <button
                      className="absolute bottom-3 right-3 flex items-center justify-center rounded-full bg-gradient-to-br from-pink-300 via-pink-400 to-purple-400 p-3 text-white shadow-md transition-transform duration-200 hover:scale-105"
                      onClick={() => handleReplyClick(issue)}
                    >
                      <FaReply size={20} />
                    </button>

                    {issue.unreadCount > 0 && (
                      <span className="absolute bottom-12 right-3 animate-bounce rounded-full bg-gradient-to-br from-red-400 via-red-500 to-pink-500 px-2 py-0.5 text-xs font-semibold text-white shadow-md">
                        {issue.unreadCount}
                      </span>
                    )}
                  </div>

                  <div className="mt-4 rounded-tl-3xl bg-gradient-to-br from-pink-300 via-pink-400 to-purple-400 py-4">
                    <p className="text-sm font-medium text-white drop-shadow-sm">
                      {issue?.userId?.fullName || "User"}
                    </p>
                    <p className="text-sm text-white opacity-90">
                      {issue?.userId?.phone?.slice(2) || "N/A"}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <p className="col-span-2 text-center tracking-wide">
                No Issues Found
              </p>
            )}
          </div>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
            />
          )}

          {isModalOpen && (
            <ReplyModal
              isOpen={isModalOpen}
              onClose={handleModalClose}
              issue={selectedIssue}
              onStatusUpdate={() => getAllIssues(currentPage)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ContactUs;
